import worldTopo from './WORLD-countries-110m-topo.json';
// get rid of the south pole :(
worldTopo.objects['WORLD-countries-110m'].geometries = worldTopo.objects[
    'WORLD-countries-110m'
].geometries.filter((geom) => geom.id !== 'ATA');

export {worldTopo};
